import axios from 'axios';
import config from '../config';
import { Device } from '../interfaces';

export const getOnboardDevices = (): Promise<Device[]> => {
    return axios.get(`${config.API_URL}/onboard-devices`).then((response: any) => {
        return response.data.data.devices;
    });
};
